<script>
  import { notification } from './store.js'
  import { onMount, onDestroy } from 'svelte'
	export let themes = {
		danger: ['#58CFEB', '#EEFFFF'],
		success: ['#83df93', '#dcf4e0'],
		warning: '#f0ad4e',
		info: '#5bc0de',
		default: '#aaaaaa'
  }
	export let timeout = 3000
	export let close = true
	let count = 0
	let toasts = [ ]
  let unsubscribe
	function animateOut(node, { delay = 10, duration = 300 }) {
		return {
			delay,
			duration,
			css: t => `opacity: ${(t-.5) * 1}; transform: translateX(5px);`
		}
	}
	function createToast (msg, theme, to) {
		const background = themes[theme] || themes['default']
		toasts = [{
			id: count,
			msg, 
			background, 
			timeout: to || timeout,
			width: '100%'
		}, ...toasts];
		count = count + 1
  }
  
  unsubscribe = notification.subscribe(value => {
    if (!value) { return }
    createToast(value.message, value.type, value.timeout)
    notification.set()
  })
  
  onDestroy(unsubscribe)
	
	function removeToast (id) { 
		toasts = toasts.filter(t => t.id != id)
	}
</script>

<style>
	:global(.toasts) {
		list-style: none;
		position: fixed;
		top: 0;
		right: 0;
		padding: 0;
		margin: 0;
		z-index: 9999;
	}
	:global(.toasts) > .toast > .content > button {
		margin-left: auto;
		margin-bottom: 0;
		border: 0;
		background: none;
		border-radius: 50px;
		height: 40px;
		width: 40px;
		cursor: pointer;
		display: flex;
		align-content: center;
		justify-content: center;
	}
	:global(.toasts) > .toast > .content > button:hover {
		background: rgba(0, 0, 0, 0.07);
		cursor: pointer;
	}
	:global(.toasts) > .toast {
		position: relative;
		margin: 10px;
		max-width: 80vw;
		min-width: 80vw;
		position: relative;
		animation: animate-in 350ms forwards;
		color: rgb(56, 54, 54);
		border-radius: .5rem;
		overflow: hidden;
		box-shadow: 0px 2px 6px rgba(0, 0, 0, .25);
	}
	
	:global(.toasts) > .toast > .content {
		padding: 10px;
		display: flex;
		align-items: center;
		font-weight: 500;
	}
	
	:global(.toasts) > .toast > .progress {
		position: absolute;
		bottom: 0;
		left: 0;
		height: 6px;
    width: 100%;
	  animation-name: shrink;
	  animation-timing-function: linear;
	  animation-fill-mode: forwards;
	}
	
	:global(.toasts) > .toast:before,
	:global(.toasts) > .toast:after {
			content:"";
			position:absolute;
			z-index:-1;
			top:50%;
			bottom:0;
			left:10px;
			right:10px;
			border-radius:100px / 10px;
	}
	
	:global(.toasts) > .toast:after {
			right:10px;
			left:auto;
			transform:skew(8deg) rotate(3deg);
	}
	
	@keyframes animate-in { 
		0% {  
			opacity: 0; 
			transform: translateY(20px);
		}
		100% { 
			opacity: 1; 
			transform: translateY(0);
		}
	}
	
	@keyframes shrink { 
		0% { 
			width: 100%; 
		}
		100% { 
			width: 0; 
		}
  }
  @media(min-width: 768px) {
    :global(.toasts) > .toast {
      max-width: 20vw;
      min-width: 20vw;
	  }
  }
	
</style>

<ul class="toasts">
	{#each toasts as toast (toast.id)}
		<li class="toast" style="background: {toast.background[1]};" out:animateOut>
			<div class="content">
				{toast.msg}
				{#if close}
					<button on:click={() => removeToast(toast.id)}>
					<svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" class="css-i6dzq1"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
					</button>
				{/if}
			</div>
			<div 
				class="progress" 
				style="background: {toast.background[0]};animation-duration: {toast.timeout}ms;"
				on:animationend={() => removeToast(toast.id) }>
			</div>
		</li>
	{/each}
</ul>

